export const SELECTOR_SIZE = "sm" as const
export const SELECTOR_VARIANT = "subtle" as const

export const SELECTOR_TRIGGER_PROPS = {
  bg: "bg",
  borderColor: "transparent",
  borderRadius: "20px",
  borderWidth: 0,
  color: "fg",
  fontWeight: "normal"
} as const
